import React, { Component } from 'react';
import './style.css';

class BookingForm extends Component {
  state = {
    name: '',
    email: '',
    phone: '',
    courses: {
      basicQaida: false,
      tajweed: false,
      tajweedImprovement: false,
      hifz: false
    },
    date: '',
    time: '',
    message: '',
    error: {},
    submissionStatus: null, // 'success', 'error', or null
    submissionMessage: '', // Message to display in notification
  };

  changeHandler = (e) => {
    const error = { ...this.state.error };
    error[e.target.name] = '';

    // Clear previous submission status on input change
    this.setState({
      [e.target.name]: e.target.value,
      error,
      submissionStatus: null,
      submissionMessage: '',
    });
  };

  courseChangeHandler = (e) => {
    const { name, checked } = e.target;
    const error = { ...this.state.error };

    if (checked) {
      error.courses = '';
    }

    this.setState(prevState => ({
      courses: {
        ...prevState.courses,
        [name]: checked
      },
      error
    }));
  };

  // Basic email format validation
  isValidEmail = (email) => {
      if (!email) return true; // Email is optional
      // Simple regex for basic email format check
      return /^\S+@\S+\.\S+$/.test(email);
  }

  // Basic phone number validation (checks for at least 7 digits after removing non-digits)
  isValidPhone = (phone) => {
      if (!phone) return false; // Phone is required
      const digits = phone.replace(/[^0-9]/g, '');
      return digits.length >= 7;
  }

  submitHandler = async (e) => {
    e.preventDefault();

    const { name, email, phone, courses, time, date, message } = this.state;
    const error = {};

    // Validation for required fields (Name and Phone)
    if (!name) {
        error.name = "Please enter your name";
    } else if (!/^[a-zA-Z\s.'-]+$/.test(name)) { // Basic name format check
         error.name = "Please enter a valid name";
    }

    if (!phone) {
        error.phone = "Please enter your phone number";
    } else if (!this.isValidPhone(phone)) {
        error.phone = "Please enter a valid phone number";
    }

    // Validation for optional fields if provided
    if (email && !this.isValidEmail(email)) {
        error.email = "Please enter a valid email address";
    }

    // No validation needed for courses, time, date, message as they are optional

    this.setState({ error });

    // If there are any errors, stop submission
    if (Object.keys(error).length > 0) {
        this.setState({ submissionStatus: 'error', submissionMessage: 'Please fix the errors in the form.' });
        return; // Stop submission if validation fails
    }

    // Proceed with submission if validation passes
    this.setState({ submissionStatus: 'submitting', submissionMessage: 'Submitting...' });

    const formData = new FormData();
    formData.append("access_key", "6b2a649f-9b96-4347-ad68-c5ce21937896"); // User's key
    formData.append("subject", "Query Submission from Dar-ul-Quran");
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("date", date);
    formData.append("time", time);
    formData.append("message", message);

    // Append selected courses
    const selectedCourses = Object.entries(courses)
        .filter(([key, value]) => value === true)
        .map(([key, value]) => key)
        .join(', ');

    if (selectedCourses) {
        formData.append("Courses Selected", selectedCourses);
    }

    try {
        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData,
            headers: {
                Accept: "application/json"
            }
        });

        const result = await response.json();
        if (result.success) {
            this.setState({
                submissionStatus: 'success',
                submissionMessage: 'Your booking was submitted successfully!',
                // Clear form fields on successful submission
                name: '',
                email: '',
                phone: '',
                courses: {
                    basicQaida: false,
                    tajweed: false,
                    tajweedImprovement: false,
                    hifz: false
                },
                date: '',
                time: '',
                message: '',
                error: {}
            });
        } else {
            this.setState({
                submissionStatus: 'error',
                submissionMessage: result.message || 'An error occurred during submission.',
            });
        }
    } catch (err) {
        this.setState({
            submissionStatus: 'error',
            submissionMessage: 'An error occurred while submitting the form.',
        });
    }
};

  render() {
    const { name, email, phone, courses, date, time, message, error, submissionStatus, submissionMessage } = this.state;

    return (
      <div id="booking-form" className="payment-section section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="payment-text">
                <span>Book Now</span>
                <h2>Book Your Quran Course & Begin Your Learning Journey</h2>
                <p>How can we reject the faith in Allah? Seeing that ye were without life, and He gave you life; then will He cause you to die, and will again bring you to life; and again to Him will ye return.</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="wpo-donations-form">
                <h2>Booking Information</h2>
                {/* Form tag attributes handled by Web3Forms POST - removed action, method, id, className here */}
                <form onSubmit={this.submitHandler} className="row">
                  {/* Hidden fields for Web3Forms - keep these */}
                  <input type="hidden" name="access_key" value="6b2a649f-9b96-4347-ad68-c5ce21937896"/>
                  <input type="hidden" name="email" value="info@thedarulquran.com"/> {/* Recipient Email */}
                  <input type="checkbox" name="botcheck" style={{ display: 'none' }}/> {/* Botcheck field */}
                  <input type="hidden" name="subject" value="Submission from Dar-ul-Quran Booking Form"/> {/* Subject */}

                  {/* Form Fields */}
                  <div className="col-12 form-group">
                    <input
                      type="text"
                      name="name" // Correct name for Web3Forms
                      value={name}
                      onChange={this.changeHandler}
                      placeholder="Name *"
                      required // Keep required as Name is required
                    />
                    <p className="error-message">{error.name || ''}</p>
                  </div>

                  <div className="col-md-6 form-group">
                    <input
                      type="email"
                      name="email" // Correct name for Web3Forms
                      value={email}
                      onChange={this.changeHandler}
                      placeholder="Email (Optional)"
                      // Email is now optional, remove required
                    />
                    <p className="error-message">{error.email || ''}</p>
                  </div>

                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      name="phone" // Correct name for Web3Forms
                      value={phone}
                      onChange={this.changeHandler}
                      placeholder="Phone *"
                      required // Keep required as Phone is required
                    />
                    <p className="error-message">{error.phone || ''}</p>
                  </div>

                  <div className="col-12 form-group">
                    <h4>Select Courses (Optional)</h4>
                    <div className="course-options">
                      {[
                        ['basicQaida', 'Basic Qaida'],
                        ['tajweed', 'Tajweed'],
                        ['tajweedImprovement', 'Tajweed Improvement'],
                        ['hifz', 'Hifz (Memorisation)']
                      ].map(([id, label]) => (
                        <div key={id} className="course-checkbox">
                          <input
                            type="checkbox"
                            id={id}
                            name={id}
                            checked={courses[id]}
                            onChange={this.courseChangeHandler}
                          />
                          <label htmlFor={id}>{label}</label>
                        </div>
                      ))}
                    </div>
                    {/* Courses error message - only show if there's an error */}
                    <p className="error-message">{error.courses || ''}</p>
                  </div>

                  <div className="col-md-6 form-group">
                    <input
                      type="date"
                      name="date" // Correct name for Web3Forms
                      value={date}
                      onChange={this.changeHandler}
                      placeholder="Preferred Date (Optional)"
                      // Date is now optional, remove required if it was present
                    />
                     {/* Date error message - only show if there's an error */}
                    <p className="error-message">{error.date || ''}</p>
                  </div>

                  <div className="col-md-6 form-group">
                    <select
                      name="time" // Correct name for Web3Forms
                      value={time}
                      onChange={this.changeHandler}
                      // Time is now optional, remove required
                    >
                      <option value="">Preferred Time (Optional) *</option>
                      <option value="morning">Morning (8AM - 12PM)</option>
                      <option value="afternoon">Afternoon (12PM - 4PM)</option>
                      <option value="evening">Evening (4PM - 8PM)</option>
                    </select>
                     {/* Time error message - only show if there's an error */}
                    <p className="error-message">{error.time || ''}</p>
                  </div>

                  <div className="col-12 form-group">
                    <textarea
                      name="message" // Correct name for Web3Forms
                      value={message}
                      onChange={this.changeHandler}
                      placeholder="Additional Information (Optional)"
                      // Message is now optional, remove required if it was present
                    ></textarea>
                    {/* Message error message - only show if there's an error */}
                    <p className="error-message">{error.message || ''}</p>
                  </div>

                  <div className="col-12 form-group mb-0">
                    <button className="theme-btn" type="submit">Book Now</button>
                  </div>

                   {/* Submission Notification */}
                    {submissionStatus && (
                        <div className={`submission-notification ${submissionStatus}`}>
                            {submissionStatus === 'submitting' ? (
                                <>Submitting...</>
                            ) : (
                                submissionMessage
                            )}
                        </div>
                    )}

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BookingForm;
